module.exports = __webpack_public_path__ + "img/course_bg1.38198f80.png";